// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"542":"d825e7d6","3251":"9b79cbba","6396":"caa6ef78","9080":"87c17543"}[chunkId] + ".chunk.css";
};